var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99962 16H17M13.4033 3.47545C13.713 3.17102 14.133 3 14.5709 3C15.0088 3 15.4287 3.17102 15.7384 3.47545C16.048 3.77988 16.222 4.19277 16.222 4.62329C16.222 5.05381 16.048 5.4667 15.7384 5.77113L6.39674 14.9561C6.21169 15.1381 5.98296 15.2712 5.7317 15.3431L3.4978 15.9839C3.43087 16.0031 3.35993 16.0043 3.29239 15.9873C3.22485 15.9702 3.16321 15.9357 3.11391 15.8872C3.06461 15.8388 3.02947 15.7782 3.01217 15.7118C2.99486 15.6454 2.99604 15.5756 3.01556 15.5098L3.66737 13.3135C3.74066 13.0668 3.87602 12.8422 4.06095 12.6605L13.4033 3.47545Z",
    stroke: "#33363F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioEditIcon);
export default __webpack_public_path__ + "static/media/portfolioEditIcon.2cc9dfc729437e881f6cc78ae6bb60ad.svg";
export { ForwardRef as ReactComponent };